<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="e3-svg" :width="Number(size)" :height="Number(size)" viewBox="0 0 24 24">
        <path fill="currentColor" d="M19 19H5V8h14m-3-7v2H8V1H6v2H5c-1.11 0-2 .89-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2h-1V1"/>
    </svg>
</template>

<script>
export default {
    name: 'CalendarBlankIcon',
    props: {
        size: {
            type: [String, Number],
            default: 24
        }
    }
};
</script>
